import { Component, Input } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { NavService } from '../../../../services/nav.service';
import { SupportService } from '../support.service';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import {MatExpansionModule} from '@angular/material/expansion';

@Component({
  selector: 'help-and-support',
  standalone: true,
  imports: [MatToolbarModule, MatIconModule,CommonModule,MatExpansionModule,NgxSkeletonLoaderModule],
  templateUrl: './help-and-support.component.html',
  styleUrl: './help-and-support.component.scss',
})
export class HelpAndSupportComponent {
  @Input() data: any = null;
  isLoading: boolean = false;
  supportData: any = null;
  constructor(
    public navService: NavService,
    private supportService: SupportService,
    private helpers: HelpersService
  ) {
    
  }
  ngOnChanges(){
    this.fetchHelpSupport();
  }
  fetchHelpSupport() {
    this.isLoading = true;
    this.supportService
      .helpSupport({ userid: this.helpers.userId() })
      .subscribe({
        next: (res:any) => {
          this.supportData = res?res:null;
        },
        error: (err) => {
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }
}
